
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/[state]/[city]/[course]/[id]",
      function () {
        return require("private-next-pages/play/[state]/[city]/[course]/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/[state]/[city]/[course]/[id]"])
      });
    }
  